import React, { Fragment } from 'react';
import Hero2 from '../../components/hero2/hero2';
import FeaturePartners from '../../components/software-company-components/FeaturePartners';
import ServiceSection from '../../components/software-company-components/ServiceSection/ServiceSection';
import About from '../../components/software-company-components/about/about';
import ProcessTechnology from '../../components/software-company-components/ProcessTechnology/ProcessTechnology';
import FaqSection from '../../components/software-company-components/FaqSection/FaqSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
//import BlogSection from '../../components/software-company-components/BlogSection/BlogSection';
import ContactSection from '../../components/software-company-components/ContactSection';
// import Header2 from '../../components/Header2/Header2';
// import Footer from '../../components/software-company-components/Footer/Footer';
import './homepage.css';

const HomePage2 = () => {

    return (
        <Fragment>
            <div>
                <main className="page_content">
                      
                 
                    <Hero2 />
                    <FeaturePartners />
                    <ServiceSection />
                    <About />
                    <ProcessTechnology />
                    <FaqSection />
                    
                    <ContactSection />
                </main>
                 {/* <a
                    href="https://wa.me/+447903771634"
                    target="_blank"
                    className="whatsapp-float"
                    title="Chat with Us"
                    rel="noopener noreferrer"
                >
                    <i className="fab fa-whatsapp"></i>
                </a> */}
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default HomePage2;